import { Controller } from "@hotwired/stimulus"

import EditorJS from '@editorjs/editorjs';
import Paragraph from '@editorjs/paragraph';
import Header from '@editorjs/header';
import EditorjsList from '@editorjs/list';
import Table from '@editorjs/table';
import Embed from '@editorjs/embed';
import RawTool from "../src/raw-tool";
import DragDrop from 'editorjs-drag-drop';
import StoredImage from '../src/stored-image/stored-image';
import Delimiter from "@coolbytes/editorjs-delimiter";
import AlignmentTune from 'editor-js-alignment-tune';
import IndentTune from 'editorjs-indent-tune';
import Underline from '@editorjs/underline';

export default class extends Controller {
  static targets = [ "output" ]

  connect() {
    Turbo.cache.exemptPageFromCache()
    const baseUrl = document.body.dataset.baseUrl;

    const EDITOR_JS_TOOLS = {
      paragraph: {
        class: Paragraph,
        tunes: ['align', "indentTune"]
      },
      header: {
        class: Header,
        tunes: ['align'],
        config: {
          placeholder: 'Enter a header',
          levels: [1, 2, 3, 4],
          defaultLevel: 2
        }
      },
      list: {
        inlineToolbar: true,
        class: EditorjsList,
        config: {
          defaultStyle: 'unordered'
        },
      },
      embed: {
        class: Embed,
        config: {
          services: {
            youtube: true
          }
        },
        inlineToolbar: true
      },
      table: {
        class: Table,
        inlineToolbar: true,
      },
      image: {
        class: StoredImage,
        config: {
          apiUrl: baseUrl + "/api/v1/autocomplete/images",
          field: "file",
          endpoints: {
            byFile:  baseUrl + '/uploadFile', // Your backend file uploader endpoint
            byUrl: baseUrl + '/fetchUrl', // Your endpoint that provides uploading by Url
          }
        }
      },
      raw: {
        class: RawTool
      },
      delimiter: {
        class: Delimiter
      },
      align: {
        class: AlignmentTune
      },
      indentTune: {
        class: IndentTune,
        version: EditorJS.version,
        config: {
          multiblock: true,
          tuneName: "indentTune",
          highlightIndent: {
            className: 'indentHighlight',
          }
        }
      },
      underline: Underline
    }
    let data = {}
    try {
      data = JSON.parse(this.outputTarget.value);
    }
    catch(e) {
      console.log("Error parsing JSON data for EditorJs: " + e);
    }

    this.editor = new EditorJS({
      tools: EDITOR_JS_TOOLS,
      // readOnly: true,
      holder: 'editor',
      data: data,
      onReady: () => {
        new DragDrop(this.editor);
      },
      onChange: async () => {
        const data = await this.editor.save();
        this.outputTarget.value = JSON.stringify(data);
        // 🔑 Makes DirtyForm, Turbo, validations work
        this.outputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      }
    });
  }
  disconnect() {
    Turbo.cache.resetCacheControl()
  }

  toggleReadonly() {
    this.editor.readOnly.toggle();
  }
}